import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

export class SwapCategoryDialogData {
    annotation: string;
    categories: string[];
}

@Component({
    selector: 'app-rename-category-dialog',
    templateUrl: './swap-category-dialog.component.html',
    styleUrls: ['./swap-category-dialog.component.scss'],
    standalone: false,
})
export class SwapCategoryDialogComponent implements OnInit {
    categories: string[];
    annotation: string;

    selectedCategoryControl: FormControl<string>;
    selectedCategory: string;

    constructor(
        public dialogRef: MatDialogRef<SwapCategoryDialogComponent, string>,
        @Inject(MAT_DIALOG_DATA)
        public injectedData: SwapCategoryDialogData
    ) {}

    ngOnInit() {
        this.annotation = this.injectedData.annotation;
        this.categories = this.injectedData.categories;

        this.selectedCategory = this.categories.find(
            (cat) => cat === this.annotation
        );
        this.selectedCategoryControl = new FormControl(this.selectedCategory);
    }

    onSelectionChange() {
        this.selectedCategory = this.selectedCategoryControl.value;
    }

    onApply() {
        this.dialogRef.close(this.selectedCategory);
    }

    onCancel() {
        this.dialogRef.close(null);
    }
}
